"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Group_Collapse: "Collapse group",
                Group_Expand: "Expand group",
                Group_ExpandOrCollapse: "Expand or collapse",
                Group_Select: "Select group",
                Group_Unselect: "Unselect group",
            }
        });
        /**
         * The Group control
         */
        var Group = /** @class */ (function (_super) {
            __extends(Group, _super);
            function Group() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(Group.prototype, "Expanded", {
                /**
                 * True if the group is currently expanded, false otherwise.
                 */
                get: function () {
                    var value = $dyn.value(this.FrameOptionValue);
                    var frameOptionButtonType = $dyn.value(this.FrameOptionButton);
                    return frameOptionButtonType !== $dyn.ui.FrameOptionButton.Hide || (value === 1 || value === "1");
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Group.prototype, "IsBreakable", {
                /**
                 * Returns whether or not the group is allowed to split.
                 */
                get: function () {
                    if ($dyn.value(this.Breakable) && $dyn.value(this.FrameOptionButton) === $dyn.ui.FrameOptionButton.None &&
                        $dyn.value(this.LayoutArrangeMethod) === $dyn.layout.ArrangeMethod.vertical &&
                        ($dyn.value(this.LayoutColumns) === "1" || $dyn.value(this.LayoutColumns) === $dyn.layout.Columns.balanced)) {
                        return true;
                    }
                    return false;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Group.prototype, "FrameOptionCSS", {
                get: function () {
                    var value = false;
                    if ($dyn.value(this.FrameOptionButton) !== $dyn.ui.FrameOptionButton.None) {
                        value = true;
                    }
                    return value;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Group.prototype, "hasNoCaptionCSS", {
                get: function () {
                    var value = false;
                    if ($dyn.value(this.FrameOptionButton) === $dyn.ui.FrameOptionButton.None) {
                        if ($dyn.value(this.FrameType) === "None") {
                            value = true;
                        }
                        else {
                            var caption = $dyn.value(this.Label);
                            value = !(caption && caption.length > 0);
                        }
                    }
                    return value;
                },
                enumerable: false,
                configurable: true
            });
            Group.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                // Variables
                this.HasFocus = $dyn.observable(false);
                this.LayoutColumns = $dyn.ui.columnsProperty($dyn.layout.Columns.balanced, this);
                this.EnabledButton = $dyn.computed(function () {
                    return $dyn.value(_this.Enabled) && !$dyn.value(_this.IsViewMode);
                });
                this.LayoutWidth = $dyn.computed(function () {
                    var width = $dyn.value(_this.Width);
                    var columns = $dyn.value(_this.LayoutColumns);
                    if (width === $dyn.ui.autoValue) {
                        width = $dyn.layout.Size.content;
                    }
                    if (width === $dyn.layout.Size.content && columns === $dyn.layout.Columns.balanced) {
                        width = $dyn.layout.Size.available;
                    }
                    return width;
                }, function (value) {
                    $dyn.setValue(_this, "Width", value);
                });
                var checkboxHandlerProvider = function () {
                    var groupControl = _this;
                    // Handles the checkbox toggleValue on frame option button
                    _this.handleCheckBoxToggleValue = function (event) {
                        if (this.allowUserChanges()) {
                            var val = $dyn.value(this.formattedValue);
                            this.formattedValue(this.computeToggleValue(val));
                            var newValue = $dyn.value(this.formattedValue);
                            if (typeof newValue === "boolean") {
                                newValue = newValue ? 1 : 0;
                            }
                            groupControl.ChangeFrameOptionValue(newValue);
                            // stop event propogation to prevent event bubble up to group header click handler
                            event.stopPropagation();
                        }
                    };
                };
                this.focusin = function () {
                    _this.HasFocus(true);
                };
                this.focusout = function () {
                    _this.HasFocus(false);
                };
                $dyn.observe(this.FrameOptionButton, function (newValue) {
                    if (_this.element) {
                        var focusClass = void 0;
                        switch (newValue) {
                            case $dyn.ui.FrameOptionButton.Hide:
                            case $dyn.ui.FrameOptionButton.Radio:
                                focusClass = ".group-frameOptionButton";
                                break;
                            case $dyn.ui.FrameOptionButton.Check:
                                focusClass = ".checkBox";
                                checkboxHandlerProvider();
                                break;
                            case $dyn.ui.FrameOptionButton.None:
                                if ($dyn.util.isEnhancedTabSequenceEnabled() && $dyn.value(_this.Label)) {
                                    focusClass = ".group_title";
                                }
                                break;
                        }
                        if (focusClass) {
                            _this.element.setAttribute("data-dyn-focus", focusClass);
                        }
                        else if (_this.element.hasAttribute("data-dyn-focus")) {
                            _this.element.removeAttribute("data-dyn-focus");
                        }
                    }
                });
                /**
                 * If we are at 300 or 400% zoom we want to set the number of columns to 1
                 */
                this._zoomModeWidthObserver = $dyn.observe($dyn.shell.zoomModeWidth, function (inZoom) {
                    if (inZoom) {
                        // check if columns > 1
                        if ($dyn.value(_this.LayoutColumns) > 1) {
                            _this._dynColumns = $dyn.value(_this.LayoutColumns);
                            $dyn.setValue(_this, "LayoutColumns", 1);
                        }
                    }
                    else if (!inZoom && _this._dynColumns !== undefined) {
                        $dyn.setValue(_this, "LayoutColumns", _this._dynColumns);
                        // clear out old
                        _this._dynColumns = undefined;
                    }
                });
            };
            /**
             * Sets the FrameOptionValue and fires off hooks listening for changes.
             */
            Group.prototype.ChangeFrameOptionValue = function (value) {
                $dyn.setValue(this, "FrameOptionValue", value);
                $dyn.applyFunction(this.FrameOptionValueChanged, this);
                if ($dyn.ax.personalizationUtil) {
                    $dyn.ax.personalizationUtil.forceUpdateFormPersonalizationData();
                }
            };
            /**
             *  Gets the header element for the container as a jQuery
             *  @returns The header for the group.
             */
            Group.prototype.getHeader = function () {
                var group = $(this.element);
                if (group.length) {
                    return group.find(".group_header")[0];
                }
            };
            /**
             *  Gets the element for the Frame Option Button
             *  @returns The Frame Option Button for the group.
             */
            Group.prototype.getFrameOptionButton = function () {
                var group = $(this.element);
                if (group.length) {
                    return group.find(".group-frameOptionButton")[0];
                }
            };
            /**
             * returns if control is available for expando personalization feature
             */
            Group.prototype.isControlAvailableForExpando = function () {
                if (this.FrameOptionButton && $dyn.value(this.FrameOptionButton) === $dyn.ui.FrameOptionButton.Hide) {
                    return true;
                }
                return false;
            };
            /**
             * @returns Frame Option button element
             */
            Group.prototype.getExpandoPersonalizationFocusTarget = function () {
                var expandoFocusElement;
                if (this.isControlAvailableForExpando()) {
                    expandoFocusElement = $(this.getFrameOptionButton());
                }
                return expandoFocusElement;
            };
            Group.prototype.getTaskGuideParams = function (options) {
                options = _super.prototype.getTaskGuideParams.call(this, options);
                if ($dyn.value(this.FrameOptionButton) !== $dyn.ui.FrameOptionButton.None) {
                    options.target = $(this.getHeader());
                }
                return options;
            };
            /**
             * Handler for keyDown events
             * @param event The keydown event that occurred.
             */
            Group.prototype.keyDown = function (event) {
                $dyn.util.handleShortcuts(this, event);
            };
            Group.prototype.dispose = function () {
                if (this._zoomModeWidthObserver) {
                    this._zoomModeWidthObserver.dispose();
                }
                _super.prototype.dispose.call(this);
            };
            /**
             * Callback for when the container header is clicked.
             */
            Group.prototype.HeaderClicked = function () {
                // don't allow the radio button to be uncheck via a click on the checked one
                var frameoption = $dyn.value(this.FrameOptionButton);
                if (frameoption === $dyn.ui.FrameOptionButton.Radio && $dyn.value(this.FrameOptionValue)) {
                    return;
                }
                if (!$dyn.value(this.Enabled) || ($dyn.value(this.IsViewMode) && (frameoption !== $dyn.ui.FrameOptionButton.Hide))) {
                    return;
                }
                if ($dyn.value(this.FrameOptionValue)) {
                    this.ChangeFrameOptionValue(0);
                }
                else {
                    this.ChangeFrameOptionValue(1);
                }
            };
            /**
             * @internal
             * @returns The ID postfix for this group.
             */
            Group.prototype.getLabelForId = function () {
                var buttonType = $dyn.value(this.FrameOptionButton);
                var labelForID = "";
                switch (buttonType) {
                    case $dyn.ui.FrameOptionButton.Hide:
                        labelForID = "_hide";
                        break;
                    case $dyn.ui.FrameOptionButton.Radio:
                        labelForID = "_radio";
                        break;
                    case $dyn.ui.FrameOptionButton.Check:
                        labelForID = "_FrameOptionCheckBox_check";
                        break;
                    default:
                        break;
                }
                return labelForID;
            };
            return Group;
        }($dyn.ui.Container));
        controls.Group = Group;
        Group.prototype.bindUpdate = true;
        Group.prototype.FrameOptionValueChanged = null;
        $dyn.ui.addPropertiesToPrototype(Group.prototype, {
            ArrangeMethod: { defaultValue: $dyn.ui.autoValue, observable: true },
            Breakable: { defaultValue: true, observable: true },
            Columns: { defaultValue: "1", observable: true },
            FrameType: { defaultValue: $dyn.ui.autoValue, observable: true },
            Label: { defaultValue: "", observable: true },
            Style: { defaultValue: $dyn.ui.autoValue, observable: true },
        });
        $dyn.ui.addObservablePropertiesToPrototype(Group.prototype, {
            FrameOptionButton: $dyn.ui.FrameOptionButton.None,
            FrameOptionValue: 1,
        });
        // tslint:disable:object-literal-sort-keys
        var groupShortucts = {
            ToggleExpansion: {
                Keys: { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] },
                Handler: function (evt) {
                    if (evt.target === this.getFrameOptionButton()) {
                        this.HeaderClicked();
                    }
                    else {
                        return false;
                    }
                },
                RecordTelemetry: false,
                ShowToUser: function (target) {
                    var show = false;
                    if ($dyn.value(this.Enabled) && target === this.getFrameOptionButton()) {
                        var frameOption = $dyn.value(this.FrameOptionButton);
                        if (frameOption !== $dyn.ui.FrameOptionButton.None && !$dyn.value(this.IsViewMode)) {
                            if (frameOption === $dyn.ui.FrameOptionButton.Radio && this.Expanded) {
                                show = false;
                            }
                            else {
                                show = true;
                            }
                        }
                    }
                    return show;
                },
                Description: function () {
                    var description = "";
                    var frameOption = $dyn.value(this.FrameOptionButton);
                    var expandedOrChecked = this.Expanded;
                    if (expandedOrChecked) {
                        if (frameOption === $dyn.ui.FrameOptionButton.Hide) {
                            description = $dyn.label("Group_Collapse");
                        }
                        else if (frameOption === $dyn.ui.FrameOptionButton.Check) {
                            description = $dyn.label("Group_Unselect");
                        }
                    }
                    else {
                        if (frameOption === $dyn.ui.FrameOptionButton.Hide) {
                            description = $dyn.label("Group_Expand");
                        }
                        else if (frameOption === $dyn.ui.FrameOptionButton.Check || frameOption === $dyn.ui.FrameOptionButton.Radio) {
                            description = $dyn.label("Group_Select");
                        }
                    }
                    return description;
                }
            }
        };
        Group.prototype.Shortcuts = $dyn.extendPrototype(Group.prototype.Shortcuts, groupShortucts);
        $dyn.adapter({ id: "ButtonGroup", controlType: "Group", template: "Group" });
        $dyn.adapter({ id: "ActionGroup", controlType: "Group", template: "ActionGroup" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
    var bindingHandlers;
    (function (bindingHandlers) {
        /**
         * Determines layout of a group button.
         */
        // TODO TFS:3745038 Move to html-binding-handlers
        var GroupButtonBindingHandler = /** @class */ (function () {
            function GroupButtonBindingHandler() {
                this.hideHtml = "<div class='group-frameOptionButton group-frameOptionButtonHide' role='button' " +
                    "data-dyn-bind=\"ariaExpanded: $data.Expanded, id: $data.Id + '_hide', attr: { 'aria-describedby': $data.Id + '_text' }, " +
                    "title: $dyn.label('Group_ExpandOrCollapse'), " +
                    "enabled: $data.Enabled, skip: $dyn.ui.skip($data), keyDown: $data.keyDown\"></div>";
                this.radioHtml = "<input type='radio' class='group-frameOptionButton group-frameOptionButtonRadio' " +
                    "data-dyn-bind=\"attr: { 'name': ($data._parent && $data._parent.Name) || ''," +
                    "'aria-setsize': ($data.Root && $data.Root.Children && $data.Root.Children()[0] && $data.Root.Children()[0].Children) ? $data.Root.Children()[0].Children().length : 1," +
                    "'aria-posinset': ($data.Root && $data.Root.Children && $data.Root.Children()[0] && $data.Root.Children()[0].Children) ? ($data.Root.Children()[0].Children().indexOf($data) + 1) : 1 }," +
                    "checked: $dyn.value($data.FrameOptionValue), id: $data.Id + '_radio', enabled: $dyn.value($data.EnabledButton), skip: $dyn.ui.skip($data) \" >";
                this.checkHtml = "<div data-dyn-role=\"CheckBox\" class='group-frameOptionButton group-frameOptionButtonCheck' " +
                    "data-dyn-bind=\"Value: $data.FrameOptionValue, toggleValue: $data.handleCheckBoxToggleValue, Style: 'Checkbox', Enabled: $data.EnabledButton, Name: $data.Name + '_FrameOptionCheckBox'," +
                    "Label: $data.Label, ShowLabel: false\"></div>";
            }
            GroupButtonBindingHandler.prototype.invoke = function (targetElement, value) {
                var button;
                var buttonClass;
                switch (value) {
                    case $dyn.ui.FrameOptionButton.Hide:
                        button = $($dyn.bindingHandlers.groupButton.hideHtml);
                        buttonClass = "group-frameOptionButtonHide";
                        break;
                    case $dyn.ui.FrameOptionButton.Radio:
                        button = $($dyn.bindingHandlers.groupButton.radioHtml);
                        buttonClass = "group-frameOptionButtonRadio";
                        break;
                    case $dyn.ui.FrameOptionButton.Check:
                        button = $($dyn.bindingHandlers.groupButton.checkHtml);
                        buttonClass = "group-frameOptionButtonCheck";
                        break;
                    default:
                        /// #DEBUG
                        $dyn.logWarning("Incorrect value: " + value + " may have been provided to groupButton binding handler");
                        /// #ENDDEBUG
                        break;
                }
                var buttonHtml = $(targetElement).children(".group-frameOptionButton" + "." + buttonClass);
                if (button && buttonHtml.length === 0) {
                    if ($(targetElement).children(".group-frameOptionButton").length > 0) {
                        $(targetElement).children(".group-frameOptionButton").detach();
                    }
                    $(targetElement).prepend(button);
                    var dataContext = $dyn.context(targetElement);
                    $dyn.dataBind(button[0], dataContext);
                }
            };
            return GroupButtonBindingHandler;
        }());
        bindingHandlers.groupButton = new GroupButtonBindingHandler();
    })(bindingHandlers = $dyn.bindingHandlers || ($dyn.bindingHandlers = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Group.js.map
